export interface Credential {
  email: string;
  password: string;
  [key: string]: any;
}

export function maskEmail(email: string): string {
  if (!email || !email.includes('@')) return '***';
  const [local, domain] = email.split('@');
  const masked = local.length <= 2 ? '***' : local[0] + '***' + local[local.length - 1];
  return `${masked}@${domain}`;
}

export function validateCredentials(creds: any): boolean {
  return !!(
    creds &&
    typeof creds.email === 'string' &&
    typeof creds.password === 'string' &&
    creds.email.trim() !== '' &&
    creds.password.trim() !== ''
  );
}
